// This file was auto-generated by 'typesafe-i18n'. Any manual changes will be overwritten.
/* eslint-disable */

import { i18n } from './i18n-util'
import { loadAllLocales } from './i18n-util.sync'

loadAllLocales()

export const L = i18n()

export default L
